import { Outlet } from "react-router-dom";

// // router-dom v6 only
// const RouterOutlet = () => {
//   return <Outlet />;
// };

// const RouterOutlet = ({ children }) => {
//     return <>{children}</>;
//   };

  const RouterOutlet = () => {
    const jsonData = { message: "Hello, this is JSON!", timestamp: Date.now() };
  
    return (
      <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
        {JSON.stringify(jsonData, null, 2)}
      </pre>
    );
  };

export default RouterOutlet;